module.exports = __webpack_public_path__ + "media/svg/symbols-98598fe4.svg";